import { render, staticRenderFns } from "./TechnologyCenterTable.vue?vue&type=template&id=5d3d5352&scoped=true&"
import script from "./TechnologyCenterTable.vue?vue&type=script&lang=js&"
export * from "./TechnologyCenterTable.vue?vue&type=script&lang=js&"
import style0 from "./TechnologyCenterTable.vue?vue&type=style&index=0&id=5d3d5352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3d5352",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VChip,VIcon,VSimpleTable})
